export default "__VITE_ASSET__DF3$6YMZ__"